import { lazy, ComponentProps } from "react"

export const PaymentMethodScreen = lazy(() =>
  import("../screens/tab-screens/PaymentMethodScreen/PaymentMethodScreen").then((m) => ({
    default: m.PaymentMethodScreen,
  }))
)

export const PaymentSentSuccessScreen = lazy(() =>
  import("../screens/tab-screens/PaymentRequestScreen/PaymentSentSuccessScreen").then((m) => ({
    default: m.PaymentSentSuccessScreen,
  }))
)

export const BusinessProfile = lazy(() =>
  import("../screens/BusinessProfile/BusinessProfile").then((m) => ({
    default: m.BusinessProfile,
  }))
)

export const NotSupportedOnWebScreen = lazy(() =>
  import("../screens/NotSupportedOnWebScreen").then((m) => ({
    default: m.NotSupportedOnWebScreen,
  }))
)

export const PlaidOAuthReturnMissingScreen = lazy(() =>
  import("../screens/PlaidOAuthReturnMissingScreen").then((m) => ({
    default: m.PlaidOAuthReturnMissingScreen,
  }))
)

export const PaymentRequestScreenWithGuard = lazy(async () => {
  const [{ PaymentRequestScreen }, { TermsNotAcceptedGuard }] = await Promise.all([
    import("../screens/tab-screens/PaymentRequestScreen/PaymentRequestScreen"),
    import("../screens/tab-screens/PaymentRequestScreen/TermsNotAccepted"),
  ])

  function PaymentRequestScreenWithGuard(props: ComponentProps<typeof PaymentRequestScreen>) {
    return (
      <TermsNotAcceptedGuard paymentRequestId={props.route.params.paymentRequestId}>
        <PaymentRequestScreen {...props} />
      </TermsNotAcceptedGuard>
    )
  }

  return { default: PaymentRequestScreenWithGuard }
})
